import { useFormContext } from 'react-hook-form';
import { useContext } from 'react';
import { FundRequestContext } from '~/context/fundrequests';

const Notes = () => {
    const [{ fundRequest }] = useContext(FundRequestContext);
    const { register, watch, formState: { errors } } = useFormContext();
    
    const noteValue = watch('note') || '';
    const characterCount = noteValue.length;
    const maxLength = 800;
    const isOverLimit = characterCount > maxLength;

    return (
        <div>
            <textarea
                rows={5}
                className={`form-control ${isOverLimit ? 'is-invalid' : ''}`}
                maxLength={maxLength}
                placeholder="You may enter one note here. You can always add more after submitting."
                {...register('note', {
                    maxLength: {
                        value: maxLength,
                        message: `Note must be ${maxLength} characters or less`
                    }
                })}
            />
            <div className="d-flex justify-content-between mt-1">
                <div>
                    {errors.note && (
                        <small className="text-danger">{errors.note.message}</small>
                    )}
                </div>
                <small className={`text-muted ${isOverLimit ? 'text-danger' : ''}`}>
                    {characterCount}/{maxLength} characters
                </small>
            </div>
            <div className="mt-1">
                <small className="text-muted">Please allow up to two to three business days for a response</small>
            </div>
        </div>
    );
};

export default Notes;
